import { useEffect } from 'react';

/** Minimal form interface: we only call trigger() with no args to validate all fields. */
interface FormWithTrigger {
  trigger: () => Promise<boolean>;
}

/**
 * Runs form validation once on mount so required-field errors (red borders, messages)
 * are visible immediately when opening the form, without submitting.
 */
export function useValidateOnMount(form: FormWithTrigger): void {
  useEffect(() => {
    void form.trigger();
  }, [form]);
}
